import { useCallback } from 'react';
import useLoginApiError from '../error/useLoginApiError';
import { CONSENT_PATH, HOME_PATH, TOS_PATH } from './routeNames';
import { AppURLSearchParams } from './searchParamKeys';
import { appUrlSearchParamsToString } from './utils';
import { useSearchParams } from 'react-router-dom';
import { LoggedInUser } from '../../common/types';
import { useAppFeaturesContext } from '../contexts/AppFeaturesContext/AppFeaturesContext';
import { LAUNCHER_REDIRECT } from '../constants';

const reload = (path: string, searchParams: string) => {
  window.location.assign(`${path}?${searchParams}`);
};

const reloadHome = (params: AppURLSearchParams) => {
  const urlSearchParams = appUrlSearchParamsToString(params);

  reload(`/${HOME_PATH}`, urlSearchParams.toString());
};

const reloadPath = (path: string, params: AppURLSearchParams) => {
  reload(path, appUrlSearchParamsToString(params));
};

export const reloadLogout = (params: AppURLSearchParams) => {
  reloadPath('/logout', params);
};

export function useReloadAreena() {
  const { loginApiHasErrored: hasLoginApiErrored } = useLoginApiError();
  const [searchParams] = useSearchParams();
  const { applicationResolution, e2eTests } = useAppFeaturesContext();

  return useCallback(
    (user: null | LoggedInUser) => {
      const launcherUri = searchParams.get(LAUNCHER_REDIRECT);

      const params: AppURLSearchParams = {
        resolution: applicationResolution,
        e2eTests,
        ...(launcherUri ? { uri: launcherUri } : {}),
      };

      const reloadsByPriority: (() => boolean)[] = [
        () => reloadTos(user, params, hasLoginApiErrored),
        () => reloadConsent(user, params),
        () => {
          reloadHome(params);
          return true;
        },
      ];

      for (const reloadFunc of reloadsByPriority) {
        if (reloadFunc()) break;
      }
    },
    [applicationResolution, e2eTests, hasLoginApiErrored, searchParams]
  );
}

function reloadTos(
  user: LoggedInUser | null,
  params: AppURLSearchParams,
  hasLoginApiErrored: boolean
) {
  if (!user || user?.latestTermsOfServiceAccepted || hasLoginApiErrored) {
    return false;
  }

  reloadPath(`/${TOS_PATH}`, params);

  return true;
}

function reloadConsent(user: LoggedInUser | null, params: AppURLSearchParams) {
  if (user?.consent?.expired === true || (user && !user.consent)) {
    console.log('Reloading to consent');
    reloadPath(`/${CONSENT_PATH}`, params);

    return true;
  }
  return false;
}
